module.exports = __webpack_public_path__ + "static/media/profile.d75c4ae1.jpg";